// extracted by mini-css-extract-plugin
module.exports = {"footer":"index_footer__go9yZ","info":"index_info__nIY3U"};